export default theme => ({
  title: {
    color: theme.palette.primary.contrastText,
    marginBottom: 12,
    fontSize: 50,
    fontFamily: "'Monoton', cursive"
  }
})



// WEBPACK FOOTER //
// ./src/views/Login/Main/styles.js